import React from 'react';

import { cn } from '@/services/utils';

const TableBody = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => {
    return (
        <tbody
            ref={ref}
            className={cn(
                'table-body [&_tr:last-child]:tw-border-0',
                className,
            )}
            {...props}
        />
    );
});

TableBody.displayName = 'TableBody';

export { TableBody };
